export default [
  {
    "id": "404",
    "name": "not-found",
    "path": "/404"
  },
  {
    "id": "500",
    "name": "error",
    "path": "/500"
  },
  {
    "id": "registration-success",
    "name": "success",
    "path": "/cadastro-sucesso"
  },
  {
    "id": "your-account",
    "name": "sua-conta",
    "path": "/conta"
  },
  {
    "id": "cards",
    "name": "formas-de-pagamento",
    "path": "/conta/cartoes"
  },
  {
    "id": "identificacao",
    "name": "login",
    "path": "/identificacao"
  },
  {
    "id": "register",
    "name": "cadastro-de-clientes",
    "path": "/cadastro"
  },
  {
    "id": "reset-password-identification",
    "name": "reset-password-identification",
    "path": "/recuperar-senha-identificacao"
  },
  {
    "id": "reset-password-otp-phone",
    "name": "recuperar-senha-otp-telefone",
    "path": "/recuperar-senha/telefone"
  },
  {
    "id": "reset-password-otp-email",
    "name": "recuperar-senha-otp-email",
    "path": "/recuperar-senha/email"
  }
]
